<template lang='pug' src='./new-patients.pug'></template>

<script>
import Loader from 'components/loader/loader'
import HeroPage from 'components/hero/hero-page/hero-page'
import CustomPatientConsultation from 'components/custom/custom-patient-consultation/custom-patient-consultation'
import CustomPatientForms from 'components/custom/custom-patient-forms/custom-patient-forms'
import CustomPatientFinance from 'components/custom/custom-patient-finance/custom-patient-finance'
import CustomPatientInsurance from 'components/custom/custom-patient-insurance/custom-patient-insurance'
import CustomPatientKidsClub from 'components/custom/custom-patient-lucas-kids-club/custom-patient-lucas-kids-club'
import CustomOfficeContest from 'components/custom/custom-office-contest/custom-office-contest'

export default {
  name: 'new-patients',
  computed: {
    props () {
      return this.$store.state.pages['new-patients']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  created () {
    if (!this.$route.hash) {
      this.$store.dispatch('VIEW_NAV', 0)
    }
  },
  components: {
    CustomPatientConsultation,
    CustomPatientForms,
    CustomPatientFinance,
    CustomPatientInsurance,
    CustomPatientKidsClub,
    CustomOfficeContest,
    HeroPage,
    Loader
  }
}
</script>



// WEBPACK FOOTER //
// new-patients.vue?149c432e